import { useEffect, useState } from "react";
import Footer from "../../comps/Footer";
import Header from "../../comps/Header";
import { get_terms_conditions_data } from "../../api/Global";

const TermsOfService = () => {
      const [get_terms_conditions, set_terms_conditions] = useState({});

      useEffect(() => {
            const handle_get_terms_conditions = async () => {
                  try {
                        const response = await get_terms_conditions_data();
                        set_terms_conditions(response?.data?.data?.terms_conditions);
                  }
                  catch (error) {
                        console.log("error", error)
                  }
            }
            handle_get_terms_conditions()
      }, [])
     
      // <-------- fetch the top on the page -------------->
      useEffect(() => {
            window.scrollTo(0, 0)
      }, [])
      return (
            <>
                  <Header />
                  <section className="relative overflow-hidden">
                        <div className="absolute inset-0 -z-10 bg-[#111315]" />
                        <div className="absolute inset-0 -z-10 theme-hero-bg" />
                        <div className="absolute inset-0 -z-10 theme-grid-overlay" />

                        <div className="relative mx-auto max-w-7xl px-6 pb-14 pt-12 md:pt-20 lg:px-8 lg:pb-20">
                              <div className="mx-auto max-w-3xl text-center">
                                    <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-amber-400/30 bg-white/5 px-4 py-2">
                                          <span className="h-2 w-2 rounded-full bg-amber-300" />
                                          <span className="text-sm font-medium text-stone-300">Service Usage Terms</span>
                                    </div>
                                    <h1 className="text-4xl font-bold tracking-tight text-white sm:text-5xl lg:text-6xl leading-tight">
                                          Terms Of Service
                                    </h1>
                                    <p className="mx-auto mt-6 max-w-2xl text-base leading-8 text-stone-200/80">
                                          These terms explain how our AC and utility services are delivered,
                                          billed, and supported so that every customer has a clear and fair experience.
                                    </p>
                              </div>
                        </div>
                  </section>

                  <section className="relative py-12 md:py-20">
                        <div className="absolute inset-0 theme-light-section -z-10" />
                        <div className="mx-auto max-w-7xl px-6 lg:px-8">
                              <div className="rounded-xl border border-stone-300/30 bg-white p-6 md:p-8 shadow-sm">
                                    <h2 className="text-2xl font-bold text-stone-900 mb-4">{get_terms_conditions?.title || "Terms Of Service"}</h2>
                                    <div
                                          className="privacy_terms text-stone-700 leading-7"
                                          dangerouslySetInnerHTML={{ __html: get_terms_conditions?.content }}
                                    />
                              </div>
                        </div>
                  </section>
                  <Footer />
            </>
      );
};

export default TermsOfService;
